import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26928 29176"
    {...props}
  >
    <path
      d="M26928 17230v5408c0 723-72 1294-210 1721-145 434-401 822-782 1163-381 349-867 684-1459 1006-1702 920-3345 1590-4921 2017-1578 421-3299 631-5159 631-2168 0-4146-335-5927-999-1787-670-3305-1636-4560-2911-1262-1268-2228-2806-2898-4613C335 18840 0 16822 0 14588c0-2195 328-4199 979-6026 657-1820 1616-3364 2891-4639 1268-1268 2813-2241 4640-2911C10330 335 12393 0 14706 0c1899 0 3581 257 5040 762 1465 506 2655 1144 3562 1913 913 768 1596 1583 2063 2444 460 861 690 1623 690 2293 0 717-269 1328-802 1834-532 512-1169 762-1919 762-407 0-801-92-1183-289-381-191-696-460-952-802-710-1104-1301-1938-1788-2503-493-559-1149-1039-1971-1420-828-388-1886-578-3167-578-1321 0-2504 230-3542 683-1038 454-1925 1117-2661 1985-736 860-1301 1925-1695 3180-388 1262-585 2655-585 4179 0 3312 762 5855 2280 7643 1518 1780 3640 2674 6354 2674 1321 0 2563-171 3726-519 1156-348 2339-841 3529-1485v-4580h-4423c-1064 0-1873-158-2418-480-546-322-815-867-815-1643 0-624 230-1150 683-1557 454-414 1072-618 1860-618h6486c795 0 1472 72 2024 211 552 144 999 460 1334 946 341 486 512 1222 512 2195z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
